import { AlignTypes } from '@monorepo-web/components-library';
import { auxFormatPercent, FormatTypes, groupAndSumByProperties, helperFormat, hexToRGBA, sumByProperties, } from '@monorepo-web/utils';
export function getColumnsDadosAgrupadosCartExp() {
    const columnsDadosAgrupados = [
        {
            id: 'nome_ativo',
            label: 'Ativo Final',
            colorLegend: true,
            freeze: true,
            width: '300px',
            noBreak: true,
        },
        {
            id: 'sbr_fim',
            label: `Saldo Bruto`,
            align: AlignTypes.right,
            headerAlign: AlignTypes.right,
        },
        {
            id: 'percent_sbr',
            label: '% do Saldo Bruto',
            align: AlignTypes.right,
            headerAlign: AlignTypes.right,
        },
    ];
    return columnsDadosAgrupados;
}
export function formatDadosAgrupados(dados_cart_explodida) {
    const dadosAgrupados = dados_cart_explodida
        ? groupAndSumByProperties(dados_cart_explodida, 'classe', 'subclasse', [
            'sbr_fim',
            'percent_sbr',
        ])
        : [];
    return dadosAgrupados;
}
export function formatRowsDadosAgrupadosCartExp(dadosAgrupados, theme, dados_cart_explodida) {
    const rowsDadosAgrupados = [];
    const totalAtivos = dados_cart_explodida
        ? sumByProperties(dados_cart_explodida, ['sbr_fim', 'percent_sbr'])
        : [];
    dadosAgrupados === null || dadosAgrupados === void 0 ? void 0 : dadosAgrupados.forEach((classe, index) => {
        var _a;
        // linha classe
        if (classe.class)
            rowsDadosAgrupados.push({
                nome_ativo: classe.class,
                colorIndex: index,
                bgColor: '#444444',
                color: theme.backgroundColor,
                bold: true,
                sbr_fim: '',
                percent_sbr: '',
                openModal: null,
            });
        (_a = classe.subclasses) === null || _a === void 0 ? void 0 : _a.forEach((subclasse) => {
            var _a;
            // linha subclasse
            if (subclasse.subclass)
                rowsDadosAgrupados.push({
                    nome_ativo: subclasse.subclass,
                    bgColor: '#E7E7E7',
                    color: theme.fontColor,
                    bold: true,
                    colorIndex: index,
                    sbr_fim: '',
                    percent_sbr: '',
                    openModal: null,
                });
            (_a = subclasse.values) === null || _a === void 0 ? void 0 : _a.forEach((ativo) => {
                // ativo
                rowsDadosAgrupados.push({
                    nome_ativo: ativo.nome_ativo,
                    sbr_fim: helperFormat(ativo.sbr_fim, FormatTypes.decimals, 2),
                    percent_sbr: helperFormat(auxFormatPercent(ativo.percent_sbr), FormatTypes.decimals, 2),
                    colorIndex: index,
                });
            });
            // total subclasse
            if (subclasse.subclass)
                rowsDadosAgrupados.push({
                    nome_ativo: `Total ${subclasse.subclass}`,
                    sbr_fim: helperFormat(subclasse.subtotal.sbr_fim, FormatTypes.decimals, 2),
                    percent_sbr: helperFormat(auxFormatPercent(subclasse.subtotal.percent_sbr), FormatTypes.decimals, 2),
                    colorIndex: index,
                    // bgColor: theme.chartLighterColors[index % theme.chartLighterColors.length],
                    bgColor: hexToRGBA(theme.chartColors[index % theme.chartColors.length], theme.hexAlphaLighter),
                    color: theme.fontColor,
                    bold: true,
                    openModal: null,
                });
        });
        // total classe
        if (classe.class)
            rowsDadosAgrupados.push({
                nome_ativo: `Total ${classe.class}`,
                sbr_fim: helperFormat(classe.subtotal.sbr_fim, FormatTypes.decimals, 2),
                percent_sbr: helperFormat(auxFormatPercent(classe.subtotal.percent_sbr), FormatTypes.decimals, 2),
                colorIndex: index,
                // bgColor: theme.chartLightColors[index % theme.chartLightColors.length],
                bgColor: hexToRGBA(theme.chartColors[index % theme.chartColors.length], theme.hexAlphaLight),
                color: theme.fontColor,
                bold: true,
                openModal: null,
            });
    });
    if (dados_cart_explodida)
        rowsDadosAgrupados.push({
            nome_ativo: 'Total',
            bgColor: '#444444',
            color: theme.backgroundColor,
            bold: true,
            sbr_fim: helperFormat(totalAtivos.sbr_fim, FormatTypes.decimals, 2),
            percent_sbr: helperFormat(100, FormatTypes.decimals, 2),
            colorIndex: null,
        });
    return rowsDadosAgrupados;
}
export function formatPieChartClasseData(dadosAgrupados) {
    const alocClasse = []; // dados para grafico pizza
    dadosAgrupados === null || dadosAgrupados === void 0 ? void 0 : dadosAgrupados.forEach((classe) => {
        // dados para grafico pizza(total da classe)
        if (classe.class)
            alocClasse.push({
                classe: `${classe.class}`,
                alocacao: classe.subtotal.percent_sbr,
            });
    });
    const pieChartClasseData = alocClasse
        ? alocClasse
            .map((obj) => ({
            name: obj.classe !== '' ? obj.classe : 'Outros',
            value: typeof obj.alocacao === 'number'
                ? Number((obj.alocacao * 100).toFixed(2))
                : Number((Number(obj.alocacao) * 100).toFixed(2)),
        }))
            .sort((a, b) => (a.value > b.value ? -1 : b.value > a.value ? 1 : 0))
        : null;
    return pieChartClasseData;
}
